import { Modal, ModalId } from "../../../../../features/ui";
import { Customer } from "../../..";
import { Labels } from "../../../../../features/data-types";
import { VatCondition } from "../../../../administration";
import { useActions } from "./actions";

type Props = {
    customer?: Customer
    vatCondition?: VatCondition
    onSubmit: (customer: Customer) => void
}

export const UpdateVatConditionModal = (props: Props) => {
    const { customer, vatCondition, onSubmit } = props

    const { updateCustomerVatCondition } = useActions()
    
    const renderBody = () => vatCondition ? <div>
        La condición de IVA seleccionada para el cliente {customer?.name} es <strong>{Labels.vatConditionLabel(vatCondition)}</strong>.
        ¿Deseás actualizar el cliente con esta condición?
    </div> : <></>

    const onUpdate = async () => {
        const updatedCustomer = await updateCustomerVatCondition(customer!.id, vatCondition!)
        onSubmit(updatedCustomer)
    }

    return (
        <Modal
            modalId={ModalId.UPDATE_VAT_CONDITION}
            title="Actualizar Condición de IVA"
            submitLabel="Actualizar Cliente"
            onSubmit={onUpdate}
        >
            {renderBody()}
        </Modal>
    )
}
